import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
const AppContext = /*#__PURE__*/React.createContext({
  mountPath: '',
  bootstrapConfig: undefined
});
export const AppContextProvider = _ref => {
  let {
    children,
    mountPath,
    bootstrapConfig
  } = _ref;
  return /*#__PURE__*/React.createElement(AppContext.Provider, {
    value: {
      mountPath,
      bootstrapConfig
    }
  }, children);
};
const useAppContext = () => {
  return useContext(AppContext);
};
export function withMountPath(WrappedComponent) {
  return function AppContextHOC(props) {
    return /*#__PURE__*/React.createElement(AppContext.Consumer, null, appContext => {
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
        mountPath: appContext.mountPath
      }, props));
    });
  };
}
export const useMountPath = () => {
  const {
    mountPath
  } = useAppContext();
  return mountPath;
};
export const useBootstrapConfig = () => {
  const {
    bootstrapConfig
  } = useAppContext();
  return bootstrapConfig;
};
export const useEnvironment = () => {
  const {
    bootstrapConfig: {
      environment
    }
  } = useAppContext();
  return environment;
};
export const useAlgoliaConfig = () => {
  const {
    bootstrapConfig: {
      algolia
    }
  } = useAppContext();
  return algolia;
};